var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"banner_warp"},[_c('img',{staticClass:"banner_warp_img",attrs:{"src":_vm.bannerImg,"alt":"Preloaded Image"}}),_c('div',{staticClass:"banner_warp_text"},[_c('h1',[_vm._v(_vm._s(_vm.bannerH))]),_c('p',[_vm._v(_vm._s(_vm.bannerP))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }